export default __webpack_public_path__ + "static/media/Beastmaster's Corded Claw.226cde23.jpg";